"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = exports.TitleSection = exports.StyledBox = void 0;
const styles_1 = require("@mui/material/styles");
const Box_1 = __importDefault(require("@mui/material/Box"));
exports.StyledBox = (0, styles_1.styled)(Box_1.default)({
    marginLeft: "1.4rem",
    position: "absolute",
    top: "50%",
    backgroundColor: "#fff",
    boxShadow: "0px 16px 32px rgba(51, 51, 51, 0.1);",
    width: 400,
    left: "50%",
    borderRadius: "8px",
    transform: "translate(-50%, -50%)",
    padding: "32px"
});
exports.TitleSection = (0, styles_1.styled)("div")({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});
exports.Content = (0, styles_1.styled)("div")({
    marginTop: "32px"
});
